import { Button } from '@utilitywarehouse/hearth-react';

import { Dialog, DialogActions, DialogID, useDialog } from '@components/Dialog';

interface BlockedSignupModalProps {
  onClose: () => void;
}

interface BlockedSignupModalUIProps {
  dialogId: DialogID;
  onClose: () => void;
}

const BlockedSignupModalUI = ({
  dialogId,
  onClose,
}: BlockedSignupModalUIProps) => (
  <Dialog
    id={dialogId}
    heading="Sorry, we can't sign you up at the moment"
    description="We're really sorry, but we're unable to supply energy to your property right now."
    hideCloseButton
    preventDismiss
  >
    <DialogActions>
      <Button onClick={onClose} variant="outline" colorScheme="destructive">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

const BlockedSignupModal: React.FC<BlockedSignupModalProps> = ({ onClose }) => {
  const { id: dialogId } = useDialog(DialogID.ENERGY_BLOCKED);

  return <BlockedSignupModalUI dialogId={dialogId} onClose={onClose} />;
};

export type { BlockedSignupModalProps, BlockedSignupModalUIProps };

export { BlockedSignupModal, BlockedSignupModalUI };
